var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.6274 8.23481C20.9133 8.1029 20.2575 8.55858 20.1216 9.25561C19.9857 9.95263 20.4428 10.6332 21.1374 10.7696C23.2288 11.1773 24.8437 12.7962 25.253 14.8947V14.8962C25.3695 15.5003 25.9013 15.9395 26.5138 15.9395C26.5959 15.9395 26.6781 15.932 26.7618 15.917C27.4564 15.7776 27.9135 15.0986 27.7776 14.4001C27.1666 11.2657 24.754 8.84489 21.6274 8.23481Z",
    fill: "#322670"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.5338 3.01188C21.1992 2.96391 20.863 3.06284 20.5956 3.2757C20.3208 3.49155 20.149 3.80334 20.1116 4.1526C20.0325 4.85861 20.5419 5.49717 21.247 5.57662C26.1094 6.11925 29.8889 9.90714 30.4356 14.7848C30.5088 15.4383 31.0571 15.9315 31.7114 15.9315C31.7607 15.9315 31.8085 15.9285 31.8578 15.9225C32.1999 15.885 32.5046 15.7157 32.7197 15.4458C32.9334 15.176 33.0305 14.8403 32.9916 14.497C32.3104 8.41117 27.6003 3.68792 21.5338 3.01188Z",
    fill: "#322670"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5476 19.4586C22.5312 25.4405 23.8887 18.5201 27.6985 22.3272C31.3714 25.9991 33.4824 26.7348 28.8289 31.3871C28.246 31.8555 24.5424 37.4914 11.5269 24.4795C-1.49022 11.466 4.14238 7.75867 4.61095 7.17592C9.2758 2.51077 9.99879 4.63407 13.6717 8.30599C17.4815 12.1147 10.564 13.4766 16.5476 19.4586Z",
    fill: "#322670"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.da7a62c7ae07a54ecd5e4cce3baad6c0.svg";
export { ForwardRef as ReactComponent };